import useNextLocation from './useLocation';

// export type UseNextRouter = ReturnType<typeof useNextLocation>;
// export type UseReactRouter<T> = ReturnType<typeof useLegacyLocation<T>>;

export default useNextLocation;
